import Permissions from "./permissions";

export const getAmountOfSteps = (permissions) => {
  const canConfigureGates = Permissions.userMayConfigureGates(permissions);
  const amountOfSteps = canConfigureGates ? 5 : 4;

  return amountOfSteps;
};
